export default __webpack_public_path__ + "static/media/144.b82256e3.jpg";